// Backwards guidance for a data-dependent step opened before its inputs exist:
// one line on what the step does, one on what's missing, and a button to the
// step that supplies it. Guide, don't gate: the rail stays open, nothing
// redirects, and a step with partial data never shows this.
import { JOURNEY_STEPS } from '@/features/project/journey-steps';
import type { StepId } from '@/features/project/step-status';
import type { HintedStepId } from '@/features/project/step-prerequisites';
import { StepLinkBar } from '@/features/project/StepLinkBar';

// What each step does, said once before the "nothing yet" line.
const LEAD: Record<HintedStepId, string> = {
  synthesis: 'This step groups what customers told you.',
  capabilities: 'Capabilities answer the needs you found.',
  thesis: 'This check compares your idea with the evidence.',
  deck: 'The deck is built from your idea and evidence.',
};

// What's missing, per step. The idea line is shared by the two steps that need one.
const MISSING: Record<HintedStepId, string> = {
  synthesis: 'Nothing to group yet.',
  capabilities: 'No needs to answer yet.',
  thesis: 'Nothing to compare yet.',
  deck: 'Nothing to draw on yet.',
};
const MISSING_IDEA = 'No idea captured yet.';

export function PrerequisiteHint({ stepId, missing }: { stepId: HintedStepId; missing: StepId }) {
  const target = JOURNEY_STEPS[missing];
  const whatIsMissing = missing === 'idea' ? MISSING_IDEA : MISSING[stepId];
  return <StepLinkBar lead={LEAD[stepId]} body={`${whatIsMissing} First: ${target.title}.`} target={target} />;
}
